angular.module('impactx.productstock').controller('EditProductStockController', [
    '$scope',
    '$mdDialog',
    'data',
    'themeFactory',
    'trns',
    'dataGen',
    '$route',
    'ToastService',
    'TranslationService',
    EditProductStockController]);

function EditProductStockController($scope, $mdDialog, data, themeFactory, trns, dataGen, $route, ToastService, TranslationService)
{
    $scope.data = data;
    $scope.trns = trns;
    $scope.theme = themeFactory.getTheme();

    this.cancel = function ()
    {
        // remove orderstop from products which had no orderstop before editing
        dataGen.postAsForm($scope, {ids: $scope.data.hadNoOrderStops}, "/productstock/orderstop/remove");

        $mdDialog.cancel();
    };

    this.answer = function ()
    {
        dataGen.postAsForm($scope, {data: $scope.data}, "/productstock/save").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $mdDialog.hide();
            $route.reload();
        });
    };
}